import "./style.scss";
import "../../../assets/css/CountryCode.scss";

import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import PropTypes from "prop-types";
import OTPInput from "otp-input-react";
import { connect } from "react-redux";
import {
  ErrorMessage, Field, Form, Formik,
} from "formik";
import { useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import jwt from "jsonwebtoken";
import { jwtDecode } from 'jwt-decode'
import { useSnackbar } from "notistack";
import React from "react";
import isEmpty from "lodash/isEmpty";
import {
  loginRequest,
  setUserRole,
  setAppBarName,
  setLayoutName,
  getUserLeftMenuCall,
  clientThemeCall,
  clientPortalConfig,
} from "../../../Redux/Actions/LoginActions";
import {
  getUserDetailsById,
  getUserProfileImage,
} from "../../../Redux/Actions/UserRegistration";
import { getOtpAction, getCountryList } from "../../../actions/login.action";
import { checkLayoutName } from "../../../Uintls/gloables";

import Validation from "../../../Utils/Validations";
import useStyles from "./Style";

const adminInitialValues = {
  clientId: "H001",
  id: "",
  password: "",
  countryCode: 1,
};
const patientInitialValues = {
  clientId: "",
  id: "",
  password: "",
  userType: "PT",
  countryCode: 1,
};

function CloneLogin(props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const windowWidth = useMediaQuery(theme.breakpoints.up("md"));
  const [onClickOtp, setOnClickOtp] = React.useState(false);
  const [action, setAction] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [loginType, setloginType] = React.useState("admin");
  const version = process.env.REACT_APP_BUILD_VERSION_NUMBER;
  const [initialValues, setInitialValues] = React.useState({});
  const [apiCalled, setApiCalled] = React.useState(false);
  const handleOtp = value => {
    setOtp(value);
  };

  const passwordLogin = function (values) {
    if (props.app.defaultTheme === false) {
      enqueueSnackbar(
        "System Error. Please contact the system administrator.",
        {
          variant: "error",
        }
      );
    } else {
      setAction(true);
      localStorage.setItem("email", values.id.toLowerCase());
      const updatedValues = {
        Email: values.id,
        clientId: values.clientId || "",
        password: values.password,
      };
      if (/^\d+$/.test(values.id)) {
        updatedValues.countryCode = values.countryCode;
      }
      props.loginRequest(updatedValues);
    }
  };

  const otpLogin = function () {
    setAction(true);
    const updatedValues = {
      Email: initialValues.id,
      clientId: initialValues.clientId || "",
      loginBy: "OTP",
      password: otp,
    };
    if (/^\d+$/.test(initialValues.id)) {
      updatedValues.countryCode = initialValues.countryCode;
    }
    props.loginRequest(updatedValues);
  };

  React.useEffect(() => {
    if (props.userData !== false) {
      if (props.userData && props.userData.status) {
        setAction(false);
        localStorage.setItem("token", `bearer ${props.userData.token}`);
        // jwt.verify(
        //   props.userData.token,
        //   "Support@Vaminfosyshserus",
        //   (err, decoded) => {
        //     if (decoded !== undefined) {
        //       props.clientThemeCall(decoded.ClientID);
        //       props.clientPortalConfig(decoded.ClientID);
        //       const idealPath = "";
        //       let LandingPage = "/";
        //       let MainCat = "";
        //       if (idealPath) {
        //         LandingPage = idealPath.landingPageName;
        //       } else {
        //         LandingPage = decoded.Role_Permission_Data.LandingPage;
        //         MainCat = decoded.Role_Permission_Data.Main_Category_LandingPage;
        //       }
        //       props.setAppBarName(
        //         MainCat ? `${MainCat} / ${LandingPage}` : LandingPage
        //       );
        //       const layoutName = checkLayoutName(
        //         decoded.Role_Permission_Data.Profile_Code
        //       );
        //       props.setLayoutName(layoutName);
        //       if (idealPath) {
        //         props.history.push(idealPath.path);
        //       } else {
        //         let userType = "";
        //         if (decoded) {
        //           if (
        //             decoded.Role_Permission_Data.Profile_Code === "MUR"
        //             || decoded.Role_Permission_Data.Profile_Code === "Merchant"
        //           ) {
        //             userType = "External";
        //           } else {
        //             userType = "Internal";
        //           }
        //         }
        //         if (!isEmpty(userType)) {
        //           localStorage.setItem("userType", userType);
        //         }
        //         localStorage.setItem("menu", JSON.stringify(decoded));
        //         localStorage.setItem("clientId", decoded.ClientID);
        //         localStorage.setItem("userId", decoded.UserID);
        //         localStorage.setItem(
        //           "sendApiClientId",
        //           JSON.stringify([decoded.ClientID])
        //         );
        //         if(!apiCalled){
        //           props.getUserDetailsById(decoded.UserID);
        //           setApiCalled(true)
        //         }
        //         props.setUserRole(decoded);
        //         props.getUserLeftMenuCall();
        //         props.history.push(
        //           `/${layoutName}/${LandingPage.replace(/\s/g, "")}`
        //         );
        //       }
        //     }
        //   }
        // );
        try {
          const decoded = jwtDecode(props.userData.token);

          if (decoded) {
            props.clientThemeCall(decoded.ClientID);
            props.clientPortalConfig(decoded.ClientID);

            const idealPath = "";
            let LandingPage = "/";
            let MainCat = "";

            if (idealPath) {
              LandingPage = idealPath.landingPageName;
            } else {
              LandingPage = decoded.Role_Permission_Data.LandingPage;
              MainCat = decoded.Role_Permission_Data.Main_Category_LandingPage;
            }

            props.setAppBarName(
              MainCat ? `${MainCat} / ${LandingPage}` : LandingPage
            );

            const layoutName = checkLayoutName(
              decoded.Role_Permission_Data.Profile_Code
            );
            props.setLayoutName(layoutName);

            if (idealPath) {
              props.history.push(idealPath.path);
            } else {
              let userType = "";

              if (
                decoded.Role_Permission_Data.Profile_Code === "MUR" ||
                decoded.Role_Permission_Data.Profile_Code === "Merchant"
              ) {
                userType = "External";
              } else {
                userType = "Internal";
              }

              if (!isEmpty(userType)) {
                localStorage.setItem("userType", userType);
              }

              localStorage.setItem("menu", JSON.stringify(decoded));
              localStorage.setItem("clientId", decoded.ClientID);
              localStorage.setItem("userId", decoded.UserID);
              localStorage.setItem(
                "sendApiClientId",
                JSON.stringify([decoded.ClientID])
              );

              if (!apiCalled) {
                props.getUserDetailsById(decoded.UserID);
                setApiCalled(true);
              }

              props.setUserRole(decoded);
              props.getUserLeftMenuCall();

              props.history.push(
                `/${layoutName}/${LandingPage.replace(/\s/g, "")}`
              );
            }
          }
        } catch (error) {
          console.error("Invalid or malformed token", error);
        }

      } else {
        setAction(false);
        enqueueSnackbar(props.userData.message, {
          variant: "error",
        });
      }
    }
  }, [props]);

  React.useEffect(() => {
    localStorage.setItem("adminLoginPath", window.location.pathname);
    localStorage.removeItem("loginPath");
  }, []);

  React.useEffect(() => {
    if (loginType === "admin") {
      setInitialValues(adminInitialValues);
    }
    if (loginType === "patient") {
      setInitialValues(patientInitialValues);
    }
  }, [loginType]);

  React.useEffect(() => {
    setOtp("");
  }, [onClickOtp]);
  if (props.app.defaultTheme.status === true) {
    var image = props.app.defaultTheme && props.app.defaultTheme.data[0].Logo_Image;
  }
  return (
    <div className="dashboardTiles" style={{ position: "relative" }}>
      <Container component="main" className={classes.rootNew}>
        <CssBaseline />
        <Paper
          className={!windowWidth ? classes.paperNewM : classes.paperNew}
          elevation={5}
        >
          <Box
            height="100%"
            p={{
              xs: 3,
              sm: 4,
              md: 5,
              xl: 6,
            }}
            display={{ xs: "none", sm: "none", md: "flex" }}
            className={`${classes.panelWidth} auth-left-panel`}
          >
            <Box
              display="flex"
              flexDirection="column"
              height="100%"
              width="100%"
              justifyContent="center"
              alignItems="center"
            >
              <div className={classes.brandLogo}>
                <img className="imgf" src={image} alt="appName" />
              </div>
              <Box mt={2} className={classes.brandTag}>
                <Typography component="h6" variant="subtitle1" align="center" />
              </Box>
            </Box>
          </Box>
          <Box
            display={{ xs: "flex", sm: "flex", md: "none" }}
            className="mobileHeader"
            container="true"
            justify="center"
          >
            <div className={classes.brandLogo}>
              <img className="imgm" src={image} alt="appName" />
            </div>
          </Box>
          <Box
            height="100%"
            pt={4}
            pb={4}
            pl={{
              xs: 4,
              sm: 6,
              md: 2,
              xl: 8,
            }}
            pr={{
              xs: 4,
              sm: 6,
              md: 2,
              xl: 8,
            }}
            display="flex"
            alignItems="center"
            className={
              !windowWidth
                ? `${classes.panelWidth} auth-right-panelM`
                : `${classes.panelWidth} auth-right-panel`
            }
          >
            {isEmpty(loginType) && (
              <Grid
                container="true"
                justifyContent="center"
                spacing={2}
                className="serviceCardList"
              >
                <Grid
                  className={`${"serviceCard"} ${"serviceCard"} ${"loginAdmin"}`}
                  xs={9}
                  onClick={() => setloginType("admin")}
                  item
                >
                  <Link>
                    <Box
                      display="flex"
                      alignItems="flex-start"
                      flexDirection="column"
                      className={`${classes.tilesCard} tiles-capsule`}
                    >
                      <Box p={3} className="tiles-head">
                        <Typography variant="h4" component="h2">
                          Admin Login
                        </Typography>
                      </Box>
                    </Box>
                  </Link>
                </Grid>

                <Grid
                  className="serviceCard serviceCard_ loginPatient"
                  xs={9}
                  onClick={() => setloginType("patient")}
                  item
                >
                  <Link>
                    <Box
                      display="flex"
                      alignItems="flex-start"
                      flexDirection="column"
                      className={`${classes.tilesCard} tiles-capsule`}
                    >
                      <Box p={3} className="tiles-head">
                        <Typography variant="h4" component="h2">
                          Patient Login
                        </Typography>
                      </Box>
                    </Box>
                  </Link>
                </Grid>
              </Grid>
            )}
            {!isEmpty(loginType) && (
              <>
                {!onClickOtp ? (
                  <>
                    <div className={classes.authInnerForm}>
                      <Formik
                        validationSchema={
                          loginType === "patient"
                            ? Validation.loginPatient
                            : Validation.loginAdmin
                        }
                        enableReinitialize
                        onSubmit={passwordLogin}
                        initialValues={initialValues}
                      >
                        {({ values, errors, dirty }) => (
                          <>
                            <Form>
                              <Typography
                                component="p"
                                variant="subtitle2"
                                style={{
                                  color: theme.palette.primary.main,
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}>
                                Welcome Viking Admin
                              </Typography>
                              <div className={classes.form}>
                                <Field
                                  as={TextField}
                                  margin="normal"
                                  fullWidth
                                  id="id"
                                  required
                                  autoComplete="new-password"
                                  error={errors.id ? true : false}
                                  label="Enter Email"
                                  name="id"
                                  autoFocus={loginType !== "admin"}
                                />
                                <ErrorMessage name="id">
                                  {(msg) => (
                                    <Typography
                                      component="span"
                                      className="error"
                                      variant="body2"
                                    >
                                      {msg}
                                    </Typography>
                                  )}
                                </ErrorMessage>
                                <ErrorMessage name="countryCode">
                                  {(msg) => (
                                    <Typography
                                      component="span"
                                      className="error"
                                      variant="body2"
                                    >
                                      {msg}
                                    </Typography>
                                  )}
                                </ErrorMessage>
                                <Field
                                  as={TextField}
                                  margin="normal"
                                  fullWidth
                                  name="password"
                                  error={errors.password ? true : false}
                                  label={"Password*"}
                                  type="password"
                                  id="password"
                                  autoComplete="new-password"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Button
                                          className={classes.forgotButton}
                                          color="primary"
                                          onClick={() => {
                                            props.history.push(
                                              "/resetPassword"
                                            );
                                          }}
                                        >
                                          Forgot?
                                        </Button>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <ErrorMessage name="password">
                                  {(msg) => (
                                    <Typography
                                      component="span"
                                      className="error"
                                      variant="body2"
                                    >
                                      {msg}
                                    </Typography>
                                  )}
                                </ErrorMessage>

                                <Grid
                                  container
                                  alignItems="center"
                                  justifyContent="center"
                                  className={classes.spaceTop3}
                                >
                                  <Grid sm={12} xs={12} item>
                                    <Button
                                      size="large"
                                      fullWidth
                                      type="submit"
                                      disabled={
                                        !isEmpty(errors)
                                        || isEmpty(values.id)
                                        || (!dirty && isEmpty(values.id))
                                        || action
                                      }
                                      variant="contained"
                                      color="primary"
                                      className={classes.submit}
                                      style={{
                                        backgroundColor:
                                          theme.palette.primary.main,
                                        color: "#fff",
                                      }}
                                    >
                                      Login
                                    </Button>
                                  </Grid>
                                </Grid>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </div>
                  </>
                ) : (
                  <div className={classes.authInnerForm}>
                    <Typography component="p" variant="body1" gutterBottom>
                      Please enter the one time code sent to
                    </Typography>
                    <Typography component="p" variant="body1">
                      {initialValues.id}
                    </Typography>
                    <Link onClick={() => setOnClickOtp(false)} color="primary">
                      <b>Change</b>
                    </Link>
                    <div className={classes.form}>
                      <Grid
                        container="true"
                        alignItems="center"
                        justifyContent="center"
                        className={classes.spaceTop}
                      >
                        <OTPInput
                          value={otp}
                          onChange={handleOtp}
                          OTPLength={6}
                          inputStyles={{
                            border: 0,
                            width: "14px",
                            borderBottom: "1px solid #cbcbcb",
                          }}
                          otpType="number"
                          disabled={false}
                        />
                      </Grid>

                      <Grid
                        container="true"
                        alignItems="center"
                        justifyContent="center"
                        style={{ marginTop: "20px" }}
                        className={classes.spaceTop}
                      >
                        <Grid sm={10} xs={10} item>
                          <Button
                            size="large"
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={otp.toString().length < 6}
                            className={classes.submit}
                            onClick={otpLogin}
                          >
                            Verify
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid
                        container="true"
                        alignItems="center"
                        justifyContent="center"
                        className={classes.spaceTop}
                      >
                        <Grid item>
                          <Typography component="p" variant="subtitle2">
                            Not received your code?
                            <Button color="primary">
                              <b>Resend code</b>
                            </Button>
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}
              </>
            )}
          </Box>
        </Paper>
      </Container>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 2rem",
          position: "absolute",
          bottom: "2rem",
          color: "white",
        }}
      >
        <i>Version: {version}</i>
        <i
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "7px",
          }}
        >
          <div>Powered By:</div>

          <img
            style={{
              width: "154px",
            }}
            className="imgf"
            src="/images/tsc_logo.png"
            alt="appName"
          />
        </i>
      </div>
    </div>
  );
}

CloneLogin.propTypes = {
  history: PropTypes.object,
  loginRequest: PropTypes.func,
  userData: PropTypes.object,
  setUserRole: PropTypes.func,
  setAppBarName: PropTypes.func,
  setLayoutName: PropTypes.func,
  getCountryList: PropTypes.func,
  clientThemeCall: PropTypes.func,
  clientPortalConfig: PropTypes.func,
  getUserLeftMenuCall: PropTypes.func,
  app: PropTypes.object,
  getUserDetailsById: PropTypes.func,
};

const mapStateToProps = ({ app }) => ({
  userData: app.userDetails,
  app,
  formData: app,
});

export default connect(mapStateToProps, {
  loginRequest,
  setUserRole,
  setAppBarName,
  clientPortalConfig,
  setLayoutName,
  getOtpAction,
  getCountryList,
  clientThemeCall,
  getUserDetailsById,
  getUserProfileImage,
  getUserLeftMenuCall,
})(CloneLogin);
